var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "flag"
  }, [_c('img', {
    staticClass: "d-inline-block",
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": require(`/src/assets/country/${_vm.country}.png`)
    }
  })]);
};

var staticRenderFns = [];
export { render, staticRenderFns };